import CustomerStep from '../components/blocks/raffleForm/CustomerStep';
import RegistrationStep from '../enums/RegistrationStep';

export const CONTACT_DUPLICITY_CHECK = '@app/registrationForm/contactDuplicityCheckAction';
export const CONTACT_DUPLICITY_DONE = '@app/registrationForm/contactDuplicityDoneAction';
export const UPDATE_TEXT_INPUT = '@app/registrationForm/updateTextInput';
export const UPDATE_SELECT_INPUT = '@app/registrationForm/updateSelectInput';
export const UPDATE_CONSENT_CHECKBOX_INPUT = '@app/registrationForm/updateConsentCheckboxInput';
export const UPDATE_BIRTHDAY_INPUT = '@app/registrationForm/updateBirthdayInput';
export const UPDATE_ACCORDIONS = '@app/registrationForm/updateAccordions';
export const RESET_ACTION = '@app/registrationForm/resetAction';
export const GO_TO_CUSTOMER_STEP = '@app/registrationForm/goToCustomerStep';
export const GO_TO_SUMMARY_STEP = '@app/registrationForm/goToSummaryStep';
export const SUBMITTED_PAYMENT_ACTION = '@app/registrationForm/submittedPaymentAction';
export const LOADED_PAYMENT = '@app/registrationForm/loadedPayment';
export const VALID_PAYMENT = '@app/registrationForm/validPayment';
export const UNAVAILABLE_SERVICE_PAYMENT = '@app/registrationForm/unavailableServicePayment';
export const SUBMITTING_PAYMENT = '@app/registrationForm/submittingPayment';
export const SUBMITTING_REGISTRATION_ACTION = '@app/registrationForm/submittingRegistrationAction';
export const SUBMITTED_REGISTRATION_ACTION = '@app/registrationForm/submittedRegistrationAction';
export const SUBMITTED_REGISTRATION_ERROR_ACTION = '@app/registrationForm/submittedRegistrationErrorAction';
export const UPDATE_DELIVERY_SERVICE_ACTION = '@app/registrationForm/updateDeliveryServiceAction';
export const UPDATE_COUNTRY_ACTION = '@app/registrationForm/updateCountryAction';
export const SET_REGISTRATION_DATA = '@app/registrationForm/setRegistrationData';

export const contactDuplicityCheckAction = () => ({
	type: CONTACT_DUPLICITY_CHECK
});

export const contactDuplicityDoneAction = (errors) => ({
	type: CONTACT_DUPLICITY_DONE,
	errors
});

export const updateTextInputAction = (name, { value = '', valid = true, errors = [], touched = null }) => ({
	type: UPDATE_TEXT_INPUT,
	name,
	data: {
		value,
		valid,
		errors,
		touched
	}
});

export const updateSelectInputAction = (name, { value = '', touched = null }) => ({
	type: UPDATE_SELECT_INPUT,
	name,
	data: {
		value,
		touched
	}
});

export const updateConsentCheckboxInput = (name, { value = false, touched = null }) => {
	const consentNamePrefix = CustomerStep.inputs.consents.namePrefix;
	const consentName = name.substr(consentNamePrefix.length);
	return {
		type: UPDATE_CONSENT_CHECKBOX_INPUT,
		name: consentName,
		data: {
			value,
			touched
		}
	};
};

export const updateBirthdayInputAction = (name, data) => ({
	type: UPDATE_BIRTHDAY_INPUT,
	name,
	data
});

export const updateAccordionsAction = (data) => ({
	type: UPDATE_ACCORDIONS,
	data
});

export const resetAction = () => ({
	type: RESET_ACTION
});

export const goToCustomerStepAction = () => ({
	type: GO_TO_CUSTOMER_STEP
});

export const goToSummaryStepAction = () => ({
	type: GO_TO_SUMMARY_STEP
});

export const submittingRegistrationAction = () => ({
	type: SUBMITTING_REGISTRATION_ACTION
});

export const submittedRegistrationAction = (registration) => ({
	type: SUBMITTED_REGISTRATION_ACTION,
	registration
});

export const submittedRegistrationErrorAction = (errors) => ({
	type: SUBMITTED_REGISTRATION_ERROR_ACTION,
	errors,
	activeStep: RegistrationStep.SUMMARY
});

export const updateDeliveryServiceAction = (deliveryService) => ({
	type: UPDATE_DELIVERY_SERVICE_ACTION,
	deliveryService
});

export const updateCountryAction = (value) => ({
	type: UPDATE_COUNTRY_ACTION,
	value
});

export const setRegistrationData = (registration) => ({
	type: SET_REGISTRATION_DATA,
	registration
});



// WEBPACK FOOTER //
// ./actions/RegistrationFormActions.js